import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo_uuspa.png';
import iconIg from '../assets/images/icon_ig.png';
import iconFb from '../assets/images/icon_fb.png';
import iconYt from '../assets/images/icon_yt.png';
import iconLine from '../assets/images/icon_line.png';
import Dropdown from '../assets/images/icon_dropdown.svg';


const Footer: React.FC = () => {
  // const currentYear = new Date().getFullYear();
  const [isRegionOpen, setIsRegionOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  return (
    <footer className="bg-[#101D23] text-white px-8">
      {/* 上部內容區 */}
      <div className="max-w-[1418px] mx-auto py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-2 md:mb-10">
          <div className="col-span-1 md:col-span-1 py-6 text-sm text-white/70">
            <div className="flex items-center justify-center md:justify-start mb-6 text-white/70">
              <img src={logo} alt="UUspa" className='h-[24px] md:h-[50px]' />
            </div>
            <p className='mb-6 text-center md:text-left text-body-xs md:text-body-s'>在城市的喧囂裡，找回內心的安靜。UuSpa 專為追求質感的您，挑選最優質的舒壓體驗。</p>
            <div className="flex flex-col justify-center items-center md:items-start space-y-3 text-body-xs md:text-body-s">
              <p>客服信箱： <a className='text-white/70' href="mailto:service@uuspa.com"><u>service@uuspa.com</u></a></p>
              <p>服務時間： 週一至週五 10:00 - 18:00</p>
              <p>線上客服： <a href="#" className='text-white/70'><u>點擊啟動 Line 即時對話</u></a></p>
            </div>
            
             
          </div>

          <div className="col-span-1 md:col-span-1 md:py-6">
            <button
              onClick={() => setIsRegionOpen((prev) => !prev)}
              className="flex w-full items-center justify-between md:mb-6 text-left md:pointer-events-none"
            >
              <h4 className="text-subtitle-m md:text-h6">探索地區</h4>
              <img
                className={`md:hidden transition-transform duration-300 ${
                  isRegionOpen ? '' : 'rotate-180'
                }`}
                src={Dropdown}
                alt=""
                width={8}
              />
            </button>
            <ul
              className={`overflow-hidden transition-all duration-300 text-body-s text-white/70 list-disc pl-5 space-y-2 ${
                isRegionOpen ? 'pt-6 max-h-96 opacity-100' : 'max-h-0 opacity-0'
              } md:max-h-none md:opacity-100`}
            >
              <li><Link to="/north" className="text-white/70 hover:text-gray-300">北部地區</Link></li>
              <li><Link to="/central" className="text-white/70 hover:text-gray-300">中部地區</Link></li>
              <li><Link to="/south" className="text-white/70 hover:text-gray-300">南部地區</Link></li>
              <li><Link to="/east" className="text-white/70 hover:text-gray-300">東部地區</Link></li>
              <li><Link to="/courses" className="text-white/70 hover:text-gray-300">全部課程</Link></li>
            </ul>
          </div>
          <div className="col-span-1 md:col-span-1 md:py-6">
            <button
              onClick={() => setIsSupportOpen((prev) => !prev)}
              className="flex w-full items-center justify-between md:mb-6 text-left md:pointer-events-none"
            >
              <h4 className="text-subtitle-m md:text-h6">客戶支援</h4>
              <img
                className={`md:hidden transition-transform duration-300 ${
                  isSupportOpen ? '' : 'rotate-180'
                }`}
                src={Dropdown}
                alt=""
                width={8}
              />
            </button>
            <ul
              className={`overflow-hidden transition-all duration-300 text-body-s text-white/70 list-disc pl-5 space-y-2 ${
                isSupportOpen ? 'pt-6 max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
              } md:max-h-none md:opacity-100`}
            >
              <li><Link to="/service/about" className="text-white/70 hover:text-gray-300">關於我們</Link></li>
              <li><Link to="/service/terms" className="text-white/70 hover:text-gray-300">服務條款</Link></li>
              <li><Link to="/service/privacy" className="text-white/70 hover:text-gray-300">隱私權政策</Link></li>
              <li><Link to="/service/return-policy" className="text-white/70 hover:text-gray-300">退換貨政策</Link></li>
              <li><Link to="/service/faq" className="text-white/70 hover:text-gray-300">常見問題</Link></li>
              <li><Link to="/service/contact" className="text-white/70 hover:text-gray-300">聯絡我們</Link></li>
            </ul>
          </div>
          <div className="col-span-1 md:col-span-1 md:py-6">
            <h4 className="text-subtitle-m md:text-h6 mb-6">追蹤我們</h4>
            <p className='text-body-s text-white/80 mb-6'>獲取最新的療癒資訊與限時優惠</p>
            {/* 社交媒體圖標 */}
            <div className="flex space-x-3 mb-6">
              <img src={iconFb} alt="Facebook" className="w-[24px] md:w-[32px] cursor-pointer" />
              <img src={iconIg} alt="Instagram" className="w-[24px] md:w-[32px] cursor-pointer" />
              <img src={iconYt} alt="YouTube" className="w-[24px] md:w-[32px] cursor-pointer" />
              <img src={iconLine} alt="Line" className="w-[24px] md:w-[32px] cursor-pointer" />
            </div>
          </div>
        </div>
        <div className="w-full bg-white/10 h-[1px] mb-10"></div>
        <div className="py-5">
          <p className='text-body-xxs md:text-body-s text-white/50'>© 2026 UuSpa. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
